/**
 * 고객 화면 주문번호 표시 SSOT (#1919 P4)
 *
 * 짧은 순번(#N)은 **진행중(활성) 주문 맥락에만** 적용 — 일일 리셋이라 과거
 * 내역엔 #1 이 매일 반복되므로, 과거 주문·영수증(법적)·푸시·이메일은 긴
 * order_number 를 유지한다(사용자 결정 2026-06-12 — 표시 범위 분리).
 *
 * 폴백 3단: daily_sequence ?? order_number ?? '#'+id
 * admin POS(orderDisplay.ts)와 동일 시맨틱 — 고객이 "#7번이요" 하면 매장
 * POS 도 같은 #7 을 본다(구두 대조).
 */

interface OrderNumberSource {
  id: number | string;
  daily_sequence?: number | null;
  order_number?: string | null;
}

/** 유효 순번 = 양의 정수만 (0/음수/NaN 은 발급기 불변식 위반 — 방어). */
function hasValidSequence(order: OrderNumberSource): boolean {
  return (
    typeof order.daily_sequence === 'number' &&
    Number.isInteger(order.daily_sequence) &&
    order.daily_sequence > 0
  );
}

/**
 * 진행중(활성) 주문의 주 표시 번호 — 짧은 순번 우선.
 * legacy 폴백도 '#' 프리픽스 유지 — 기존 menu 표시(`#{order_number}`)와
 * 시각 일관성(codex P4: 프리픽스 소실 회귀 방지).
 */
export function activeOrderDisplayNumber(order: OrderNumberSource): string {
  if (hasValidSequence(order)) {
    return `#${order.daily_sequence}`;
  }

  return order.order_number ? `#${order.order_number}` : `#${order.id}`;
}

/**
 * 보조 병기 번호 — 짧은 순번을 주 표시로 쓸 때 전체 order_number 를 함께
 * 노출(매장 문의/검색 대조용). 순번이 없으면 null(중복 병기 방지).
 */
export function activeOrderSecondaryNumber(order: OrderNumberSource): string | null {
  if (hasValidSequence(order)) {
    return order.order_number ?? null;
  }

  return null;
}
